import {cloneElement} from 'react';
import {connect} from 'react-redux';

const Aggregator = ({children, ...props}) => cloneElement(children, props);

const mapStateToProps = ({media}, {files}) => {
    let loaded = 0;
    let total = 0;

    files.forEach(filepath => {
        const local = media[filepath] || null;

        if (local === null) return;

        loaded += local.loaded;
        total += local.total;
    });

    if (total === 0) return {percent: null};

    return {
        percent: Math.floor((loaded / total) * 100),
    };
};

export default connect(mapStateToProps)(Aggregator);



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/DownloadButton/Aggregator.js